module.exports = __webpack_public_path__ + "images/icon-gift-1-b8e90dc70e9ba19f9781b9f32936b780.png";